// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{
    isOpen: boolean;
    product?: CartLineModel | ProductContextModel;
}>;

export const DispatchSetCutProductsModalOpen: HandlerType = props => {
    props.dispatch({
        type: "xCutProducts/SetModalOpen",
        isOpen: props.parameter.isOpen,
        product: props.parameter.product,
    } as any);
};

export const chain = [DispatchSetCutProductsModalOpen];

const setCutProductsModalOpen = createHandlerChainRunner(chain, "OpenCutProductsModal");

export default setCutProductsModalOpen;
